export const CATEGORIES = [
  { id: 'habit', name: 'Habits', icon: 'checkmark-circle', color: '#6BCB77' },
  { id: 'symptom', name: 'Symptoms', icon: 'medical', color: '#E74C3C' },
  { id: 'trigger', name: 'Triggers', icon: 'flash', color: '#F39C12' },
  { id: 'wellness', name: 'Wellness', icon: 'heart', color: '#9B59B6' },
  { id: 'coping', name: 'Coping Skills', icon: 'sparkles', color: '#4D96FF' },
];

export const ICONS = [
  'heart', 'star', 'sunny', 'moon', 'leaf', 'water', 'fitness', 'bicycle',
  'walk', 'bed', 'cafe', 'restaurant', 'book', 'musical-notes', 'brush',
  'game-controller', 'people', 'paw', 'flower', 'earth', 'sparkles', 'flash',
  'bulb', 'rocket', 'trophy', 'ribbon', 'medkit', 'bandage', 'eye', 'hand-left'
];

